<div class="informe-ventas">
  <div *ngIf="data">
    <!-- Sección de KPIs -->
    <div class="seccion-kpis">
      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Ventas Totales</div>
        <div class="valor-kpi">{{ data.kpis.ventasTotales | currency: 'EUR': 'symbol': '1.2-2' }}</div>
        <div class="unidad-kpi">€</div>
      </div>

      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Citas Completadas</div>
        <div class="valor-kpi">{{ data.kpis.citasCompletadas }}</div>
        <div class="unidad-kpi">reservas</div>
      </div>

      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Clientes Atendidos</div>
        <div class="valor-kpi">{{ data.kpis.clientesAtendidos }}</div>
        <div class="unidad-kpi">únicos</div>
      </div>

      <div class="tarjeta-kpi">
        <div class="etiqueta-kpi">Ticket Promedio</div>
        <div class="valor-kpi">{{ data.kpis.ticketPromedio | currency: 'EUR': 'symbol': '1.2-2' }}</div>
        <div class="unidad-kpi">€</div>
      </div>
    </div>

    <!-- Gráfico de Ventas por Empleado -->
    <div class="seccion-grafico" *ngIf="data.resumenPorEmpleado.length > 0">
      <h3>Ventas por Empleado</h3>
      <div class="contenedor-grafico">
        <canvas baseChart
          [datasets]="salesChartData"
          [labels]="salesChartLabels"
          [chartType]="salesChartType"
          [options]="salesChartOptions">
        </canvas>
      </div>
    </div>

    <!-- Tabla de Transacciones -->
    <div class="seccion-tabla">
      <h3>Detalle de Transacciones</h3>
      <div *ngIf="data.filas.length > 0; else sinRegistros" class="tabla-responsiva">
        <table class="tabla-informe">
          <thead>
            <tr>
              <th>Fecha/Hora</th>
              <th>Cliente</th>
              <th>Empleado</th>
              <th>Servicio</th>
              <th>Precio</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data.filas; trackBy: trackByRow">
              <td>
                <small>{{ row.inicio | date: 'short' }}</small>
              </td>
              <td>{{ row.nombreCliente }}</td>
              <td>{{ row.nombreEmpleado }}</td>
              <td>{{ row.nombreServicio }}</td>
              <td class="texto-derecha">{{ row.precio | currency: 'EUR': 'symbol': '1.2-2' }}</td>
              <td>
                <span class="insignia-estado" [ngClass]="'estado-' + row.estado?.toLowerCase()">
                  {{ row.estado }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #sinRegistros>
        <p class="sin-datos">No se encontraron transacciones</p>
      </ng-template>
    </div>

    <!-- Resumen por Empleado -->
    <div class="seccion-tabla">
      <h3>Resumen por Empleado</h3>
      <div *ngIf="data.resumenPorEmpleado.length > 0; else sinEmpleados" class="tabla-responsiva">
        <table class="tabla-informe">
          <thead>
            <tr>
              <th>Empleado</th>
              <th>Ventas Totales</th>
              <th>Completadas</th>
              <th>Clientes</th>
              <th>Ticket Prom.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let summary of data.resumenPorEmpleado; trackBy: trackByEmployee">
              <td><strong>{{ summary.nombreEmpleado }}</strong></td>
              <td>{{ summary.ventasTotales | currency: 'EUR': 'symbol': '1.2-2' }}</td>
              <td>{{ summary.citasCompletadas }}</td>
              <td>{{ summary.clientesAtendidos }}</td>
              <td>{{ summary.ticketPromedio | currency: 'EUR': 'symbol': '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #sinEmpleados>
        <p class="sin-datos">No hay datos de empleados</p>
      </ng-template>
    </div>
  </div>
  <div *ngIf="!data" class="sin-datos">No hay datos disponibles</div>
</div>
